import { useSearchParams } from 'react-router'
import { getCurrentMonthValue } from '@/src/utils/dateUtils'

export const usePeriodValueFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const periodValue = searchParams.get('periodValue') || getCurrentMonthValue()

  const setPeriodValue = (newPeriodValue: string) => {
    setSearchParams(
      (prev) => {
        prev.set('periodValue', newPeriodValue)
        return prev
      },
      { replace: true }
    )
  }

  return { periodValue, setPeriodValue }
}
